// Default Values
export const FeatureFlags = {
  isLoading: false,
  LocalizationV2: false,
  BingAdsOfferEnabled: false,
  UHFEnabled: true,
  TSEnabled: false,
  M365CopilotOfferUpdateEnabled: false,
  D365CopilotOfferUpdateEnabled: false,
  MC4NPOfferUpdateEnabled: false,
  ModernSponsorshipPhase1: false,
  M365CopilotDiscountOfferEnabled: false,
  goodstackEnabled: false,
  AccountGuardExpansionEnabled: false,
  BusinessPremiumAndE1NPGrantSunsetEnabled: false,
  tradescreeningPhaseTwoEnabled: false,
  AVSEnabled: false,
  avsResponseRulesEnabled: false,
  RtfpEnabled: false,
  regEditv2Enabled: false,
  ContactUsAgentEnabled: false,
  enableMultiRegIdSelection : false,
  EligibilityPreCheckSectionEnabled: false,
  profilePageEnhancementsEnabled: false,
  ProfileAttestationEnabled: false,
  feedbackLoopEnabled: false,
  profileEnhancementsPhase2Enabled: false,
  BusinessStandardPriceUpdateEnabled: false
};
